import * as types from './types'
import { MY_PROFILE, PHOTO } from 'common/endpoints'
import { openModal, clearModal } from '../modals/actions'
import { PROFILE_UPDATE_MODAL, UPLOAD_PHOTO_MODAL } from 'components/Modal/modalTypes'

export const fetchMyProfile = ({ silent } = {}) => ({
  type: types.FETCH_MY_PROFILE,
  meta: { url: MY_PROFILE, silent },
})

export const updateProfile = data => ({
  type: types.UPDATE_PROFILE,
  meta: {
    method: 'PUT',
    data,
    url: MY_PROFILE,
    onSuccess: [fetchMyProfile(), openModal(PROFILE_UPDATE_MODAL)],
  },
})

export const uploadPhoto = (file, coords) => {
  const formData = new FormData()
  formData.append('mediaItem', file)
  formData.append('croppingCoordinates', coords)

  // WARNING: setting to true showcases bugs due to image not being approved
  // https://strcdrs.atlassian.net/wiki/spaces/DD/pages/331788/Default+profile+picture
  formData.append('defaultItem', false)

  return {
    type: types.UPLOAD_PHOTO,
    meta: {
      method: 'POST',
      data: formData,
      url: PHOTO.UPLOAD,
      onSuccess: [fetchMyProfile(), clearModal(UPLOAD_PHOTO_MODAL)],
    },
  }
}

export const setDefaultImage = (nickname, imageId) => ({
  type: types.SET_DEFAULT_IMAGE,
  meta: {
    url: PHOTO.setDefault(nickname, imageId),
    onSuccess: fetchMyProfile(),
  },
})

export const deleteImage = (nickname, imageId) => ({
  type: types.DELETE_IMAGE,
  meta: {
    url: PHOTO.delete(nickname, imageId),
    onSuccess: fetchMyProfile(),
  },
})
